<template>
    <div id="prjAvailUser">
        <b-button @click="moveFromAvailableToMembers" variant="outline-success"
            size="sm" class="btn-assign">ASSIGN</b-button>
        <b-form-group class="mb-0 m">
            <b-form-input id="filter-input" v-model="filterInput" type="search" placeholder="Enter to Search" class="mb-0"
                v-on:keyup.enter="filter = filterInput"></b-form-input>
        </b-form-group>

        <b-table head-variant="light" :fields="fields" style="width:100%; max-height: 29.3em;" id="my-table" :items="items"
            ref="table" responsive small class="mb-0 table-wrap" hover outlineless borderless sticky-header :filter="filter" selectable
            :filter-included-fields="filterOn" @filtered="onFiltered" @row-clicked="onRowClicked">
            <template v-slot:cell(selected)="data">
                <span aria-hidden="true" v-if="data.item.selected || data.item.show"
                    :class="{ 'text-danger font-weight-bold': data.item.show }">
                    <svg xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none">
                        <rect x="0.5"
                            y="0.5"
                            width="15"
                            height="15"
                            rx="3.5"
                            fill="#1755CC"/>
                        <path d="M5 8L7 10L11 6"
                            stroke="white"
                            stroke-width="2"
                            stroke-linecap="round"/>
                        <rect x="0.5"
                            y="0.5"
                            width="15"
                            height="15"
                            rx="3.5"
                            stroke="#1755CC"/>
                    </svg>
                </span>
                <span aria-hidden="true" v-else>
                    <svg xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none">
                        <g clip-path="url(#clip0_939_25212)">
                        <rect x="0.5"
                                y="0.5"
                                width="15"
                                height="15"
                                rx="3.5"
                                fill="white"
                                stroke="#C4C4CD"/>
                        </g>
                        <defs>
                        <clipPath id="clip0_939_25212">
                            <rect width="16"
                                height="16"
                                rx="4"
                                fill="white"/>
                        </clipPath>
                        </defs>
                    </svg>
                </span>
                <span class="sr-only" v-if="data.item.selected || data.item.show">Selected</span>
                <span class="sr-only" v-else>Not selected</span>
            </template>
        </b-table>
    </div>
</template>
<script>
export default {
    props: ['propItems'],
    components: {},
    data() {
        return {
            fields: [],
            items: [],
            filter: null,
            filterInput: null,
            filterOn: [],
        }
    },
    created() {
        // this.items = this.propItems.map((item) => ({
        //     ...item,
        //     selected: false,
        // }));
        this.items = this.propItems;
        this.fields = [
            {
                key: "selected",
                label: "",
                thClass: ["text-center"],
                class: ["text-center", "align-middle", "columnRate5"]
            },
            {

                key: "userName",
                label: "NAME",
                thClass: ["text-center"],
                class: ["text-center", "align-middle"]
            },
            {

                key: "userId",
                label: "ID",
                thClass: ["text-center"],
                class: ["text-left", "align-middle"]
            },
        ]
    },
    watch: {
        'propItems': {
            handler() {
                this.items = this.propItems
            },
            deep: true,
            immediate: true // 컴포넌트가 생성될 때도 watch 핸들러를 호출할지 여부 설정
        }
    },
    methods: {
        onFiltered(filteredItems) {
            // Trigger pagination to update the number of buttons/pages due to filtering
            this.totalRows = filteredItems.length
            this.currentPage = 1
        },
        onRowClicked(item) {
            if (item.show) return;
            if (this.selectType == 'single' && item.selected != true) {
                this.items.forEach(item => item.selected = false)
            }
            item.selected = !item.selected;
        },
        moveFromAvailableToMembers() {
            let selected = this.items.filter(user => user.selected);
            this.$emit('moveFromAvailableToMembers', selected);
        },
    }
}
</script>
<style>
#filter-input {
    height: 2em;
}

.columnRate5 {
    width: 5%;
}

#project-form .table-wrap .table thead {
    background-color: transparent;
}

#project-form .table-wrap {
    margin-top: 2rem;
    border-radius: 10px;
    border: 1px solid #DDDDE3;
}

#project-form .table-wrap .table .thead-light th {
    padding: 0.666rem;
    border-bottom: 1px solid #DDDDE3;
    background-color: #F6F6FA;
    color: #2E2E38;
    text-align: center;
    font-family: 'NanumGothic';
    font-size: 14px;
    font-weight: 700;
    line-height: 150%;
}

#project-form .table-wrap .table.b-table > tbody > .table-active,
#project-form .table-wrap .table.b-table > tbody > .table-active > td {
    background-color: transparent;
}

#project-form .table-wrap .table.b-table.table-hover > tbody > tr.table-active:hover td {
    background-image: none;
}

#project-form .table-wrap .table tr td {
    padding: 0.666rem;
    border-bottom: 1px solid #E7E7EE;
    color: #2E2E38;
    text-align: center;
    font-family: 'NanumGothic';
    font-size: 14px;
    font-weight: 500;
    line-height: 150%;
    text-align: center;
}

#project-form .table-wrap .table tr:last-child td {
    border-bottom: none;
}
</style>